<template>
    <router-view :key="$route.meta.type"></router-view>
</template>

<script>
  export default {
    name: 'InvoiceLayout'
  };
</script>
